import axios from "axios";
import { toast } from "react-toastify";

export const addtocart = async (product, type, fetchbag, price, size) => {
  const userDataString = localStorage.getItem("userData");
  const userData = userDataString ? JSON.parse(userDataString) : null;

  if (userData) {
    try {
      // Retrieve and parse user data

      if (!userData?.id) {
        toast.error("User not logged in.");
        return;
      }

      // Prepare form data
      const formData = new FormData();
      formData.append("cust_id", userData.id);
      formData.append("prod_id", product);
      formData.append("type", type);
      if(type==="cart"){
        formData.append("prod_size", size);
        formData.append("prod_price", price);
      } else {
        formData.append("prod_size", "");
        formData.append("prod_price", "");

      }


      // Send POST request
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/customer/cart_add.php`,
        formData
      );

      // Handle response
      if (res.data.status) {
        toast.success(`Added to ${type === "cart" ? "cart" : "wishlist"}!`);
        if (typeof fetchbag === "function") {
          fetchbag(type);
        }
      } else {
        toast.error(`❌ Failed: ${res.data.message}`);
      }
    } catch (err) {
      console.error("Cart error:", err);
      toast.error(`🚫 Error adding to ${type}.`);
    }
  } else {
    toast.error(`Login before adding to ${type}.`);
  }
};
